import React from "react";
import LoginComponent from "../../components/Auth/LoginComponent";
import Layout from "../../components/Layout/Layout";

const Login = () => {
  return (
    <>
      <Layout>
        <LoginComponent />
      </Layout>
    </>
  );
};

export default Login;
